import { render } from "./transferOrders.vue?vue&type=template&id=0acfdff6"
import script from "./transferOrders.vue?vue&type=script&lang=js"
export * from "./transferOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__